import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { Eye, EyeOff } from "lucide-react";

// import { resetPassword } from "../../redux/slices/authSlice";

import "../Loginsignup/login-signup.css";

export default function ResetPassword() {
  // const dispatch = useDispatch();
  const navigate = useNavigate(); // Define navigate
  const { loading, error } = useSelector((state) => state.auth); // Define loading and error
  const [passwordData, setPasswordData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  useEffect(() => {
    // body bg color
    document.body.style.backgroundColor = "#f0f0f0";
    return () => {
      document.body.style.backgroundColor = "#fff";
    };
  }, []);

  const handleChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (passwordData.password === "" || passwordData.confirmPassword === "") {
      toast.error("Both fields are required");
      return;
    }

    if (passwordData.password !== passwordData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;
    if (!passwordRegex.test(passwordData.password)) {
      toast.error("Password must be at least 8 characters long, include one uppercase letter, one number, and one special character");
      return;
    }

    // dispatch(resetPassword(passwordData.password));
    toast.success("Password reset successful");
    navigate("/login");
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Left Panel - Candy World */}
        <div className="login-panel candy-panel">
          <div className="candy-content">
            <h2 className="candy-title">Your Candy World</h2>
            <h3 className="candy-subtitle">Awaits</h3>
            <div className="curved-line"></div>
            <p className="candy-description">
              Manage your orders, track shipments, and discover exclusive deals. Enjoy new arrivals, special discounts,
              and a world of delightful treats just for you!
            </p>
          </div>
          <div className="candy-image">
            <img
              src="https://res.cloudinary.com/ddpqqr6v0/image/upload/v1743740274/1_vmlfgu.png"
              alt="Candy character"
            />
          </div>
        </div>

        {/* Right Panel - Reset Password Form */}
        <div className="login-panel form-panel">
          <div className="brand-logo">
            <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1742812127/derby-logo_1_goi8kp.png" alt="Derby logo" className="logo-image" />
          </div>
          <div className="form-header">
            <h2>Reset Password</h2>
            <p className="form-subtitle">
              Enter your new password
            </p>
          </div>

          {error && <div className="error-message">{error}</div>}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group password-group">
              <input
                type={passwordVisible ? "text" : "password"}
                name="password"
                placeholder="New Password"
                value={passwordData.password}
                onChange={handleChange}
                required
              />
              <button type="button" className="password-toggle" onClick={togglePasswordVisibility}>
                {passwordVisible ? <EyeOff size={24} /> : <Eye size={24} />}
              </button>
            </div>

            <div className="form-group password-group">
              <input
                type={confirmPasswordVisible ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm Password"
                value={passwordData.confirmPassword}
                onChange={handleChange}
                required
              />
              <button type="button" className="password-toggle" onClick={toggleConfirmPasswordVisibility}>
                {confirmPasswordVisible ? <EyeOff size={24} /> : <Eye size={24} />}
              </button>
            </div>

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "Processing..." : "Reset Password"}
            </button>
          </form>

          <div className="auth-switch">
            <p>
              Remembered your password? <a href="/login">Login</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
